module.exports = __webpack_public_path__ + "static/6-14dde76da0aea72ee2744de6ce8eb51d.jpg";